import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            每日精选热门影片，51影院为你网罗第九影院、yy影院等平台最新好片
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((card) => (
            <article
              key={card.title}
              className="group rounded-2xl bg-background-50 border border-background-200 overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`51影院 - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 line-clamp-1">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {card.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}